import React, { useState } from 'react'
import i18n from 'i18next'

import Select from '../form/Select'
import utils from './utils'
import Panel from '../../UniformComponents/Panel'
import Button from '../../UniformComponents/Button'
import PageSection from './PageSection'
import Switch from '../../UniformComponents/Switch'
import AppLoading from '../AppLoading'
import PageTranslate from './PageTranslate'
import MissingTranslations from './MissingTranslations'

const SurveyTranslate = ({ survey, locales, defaultLocale, store }) => {
    const { exitPages, standardPages } = survey
    const [targetLocale, setTargetLocale] = useState(defaultLocale)
    const [showPage, setShowPage] = useState(standardPages.reduce((map, { id }) => ({ ...map, [id]: false }), {}))
    const [allowEditing, setAllowEditing] = useState(false)
    const [editableQuestions, setEditableQuestions] = useState(new Map())
    const [editablePages, setEditablePages] = useState(utils.getEditablePages(survey))
    const [loading, setLoading] = useState(false)

    const togglePage = (pageId) => {
        setShowPage({
            ...showPage,
            [pageId]: !showPage[pageId],
        })
    }

    const toggleEditing = (allowEditing) => {
        setEditableQuestions(allowEditing ? utils.getEditableQuestions(standardPages) : new Map())
        setEditablePages(utils.getEditablePages(survey))
        setAllowEditing(allowEditing)
    }

    const toggleAllPages = (value) => {
        setShowPage(standardPages.reduce((map, { id }) => ({ ...map, [id]: value }), {}))
    }

    const save = async () => {
        setLoading(true)
        await utils.saveSurveyTranslation(store, survey, editableQuestions, editablePages, defaultLocale)
        toggleEditing(false)
        setLoading(false)
    }

    return (
        <>
            {loading && <AppLoading position="fixed" zIndex={1001} />}
            <Panel className="builder-right-floating-panel">
                <div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <h3>{i18n.t('translation.title')}</h3>
                        <Button
                            cssClass="tertiary regular"
                            onClick={() => { store.showTranslate = false }}
                            label="Back to Survey Builder"
                            icon="fal fa-folder-arrow-down"
                        />
                    </div>
                    <MissingTranslations
                        survey={survey}
                        availableLocales={locales}
                        saving={loading}
                    />

                    <br />

                    <hr />

                    <br />

                    <div className="builder-right-floating-panel-bottom-content">
                        <div className="builder-right-floating-panel-actions">
                            <Switch
                                label="Edit Translations"
                                onToggle={toggleEditing}
                                optimisticUpdate={false}
                                state={allowEditing}
                            />
                            {allowEditing && (
                                <Button
                                    cssClass="secondary regular"
                                    label={i18n.t('save')}
                                    icon="fa-light fa-floppy-disk"
                                    onClick={save}
                                />
                            )}
                        </div>

                        <div className="builder-right-floating-panel-info-container">
                            <Switch
                                label={i18n.t('report_expand_pages')}
                                onToggle={toggleAllPages}
                                />
                            <Button
                                cssClass="tertiary regular"
                                label={i18n.t('export_CSV')}
                                icon="fal fa-folder-arrow-down"
                                onClick={() => { store.downloadModalOpen = true }}
                            />
                        </div>
                    </div>
                </div>
            </Panel>
            <Panel>
                <table style={{ width: '100%' }} className="survey">
                    <thead>
                        <tr>
                            <th style={{ width: '2px' }} className="oid" />
                            <th style={{ width: '250px' }}>{i18n.t('translation.section')}</th>
                            <th style={{ width: 'calc(50% - 126px)' }}>
                                {i18n.t('translation.base_language')}
                                <br />
                                {locales.find(({ value }) => value === defaultLocale)?.label}
                            </th>
                            <th style={{ width: 'calc(50% - 126px)' }}>
                                {i18n.t('translation.target_language')}
                                <br />
                                <Select
                                    options={locales}
                                    defaultValue={targetLocale}
                                    onBlur={({ value }) => { setTargetLocale(value) }}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <PageTranslate
                            key="welcome"
                            title={i18n.t('s_alt_welcomepage')}
                            content={editablePages.get('welcome')}
                            defaultLocale={defaultLocale}
                            targetLocale={targetLocale}
                            allowEditing={allowEditing}
                            id="welcome"
                        />
                        {
                            standardPages.map((page) => (
                                <PageSection
                                    show={showPage[page.id]}
                                    togglePage={togglePage}
                                    page={page}
                                    defaultLocale={defaultLocale}
                                    targetLocale={targetLocale}
                                    appStore={store}
                                    allowEditing={allowEditing}
                                    editableQuestions={editableQuestions}
                                />
                            ))
                        }
                        {
                            exitPages.map((page) => (
                                <PageTranslate
                                    key={page.id}
                                    title={page.title}
                                    content={editablePages.get(page.id)}
                                    defaultLocale={defaultLocale}
                                    targetLocale={targetLocale}
                                    allowEditing={allowEditing}
                                    id={page.id}
                                />
                            ))
                        }
                    </tbody>
                </table>
            </Panel>
        </>
    )
}

export default SurveyTranslate
